import  { change, reset } from 'redux-form'

export const RESET_DIALOG_STATE = 'formDialog/RESET_DIALOG_STATE'
export const RESET_LOOKUP_VALUE = 'formDialog/RESET_LOOKUP_VALUE'
export const SHOW_DIALOG = 'formDialog/SHOW_DIALOG'
export const SET_CONFIRMATION_ITEM =  'formDialog/SET_CONFIRMATION_ITEM'
export const SET_FORM_VALUES =  'formDialog/SET_FORM_VALUES'

const initialState = {
  confirmationItem: {},
  formValues: {},
  formType: 'new',
  lookUpValue: '',
  open: false
}

export const reducer = (state = initialState, action) => {
  switch(true) {
    case /DIALOG_RECEIVE/.test(action.type):
      return {
        ...state,
        open: false
      }
    case /DIALOG_FAILURE/.test(action.type):
      return {
        ...state,
        open: false
      }
    case /PARTNER_RECEIVE/.test(action.type):
      return {
        ...state,
        lookUpValue: action.payload.data.item.name
      }
    case /PARTNER_REQUEST/.test(action.type):
      return {
        ...state,
        lookUpValue: 'loading...'
      }
    case /PARTNER_FAILURE/.test(action.type):
      return {
        ...state,
        lookUpValue: ''
      }
    case /RESET_DIALOG_STATE/.test(action.type):
      return {
        ...state,
        confirmationItem: {},
        lookUpValue: '',
        formValues: {}
      }
    case /RESET_LOOKUP_VALUE/.test(action.type):
      return {
        ...state,
        lookUpValue: ''
      }
    case /SHOW_DIALOG/.test(action.type):
      return {
        ...state,
        open: action.dialogState,
        formType: !action.dialogAction ? state.formType : action.dialogAction
      }
    case /SET_CONFIRMATION_ITEM/.test(action.type):
      return {
        ...state,
        confirmationItem: action.item
      }
    case /SET_FORM_VALUES/.test(action.type):
      return {
        ...state,
        formValues: action.formValues
      }
    default:
      return state
  }
}

export const setConfirmationItem = (item) => ({ type:SET_CONFIRMATION_ITEM, item})

export const setFormValues = (formValues) => ({ type: SET_FORM_VALUES, formValues })

export const resetLookUpValue = () => ({ type: RESET_LOOKUP_VALUE })

export const resetFormValue = (formName, fieldName, value) => {
  return (dispatch) => {
    dispatch(change(formName, fieldName, value))
  }
}

export const resetForm = () => {
  return (dispatch) => {
    dispatch({ type: RESET_DIALOG_STATE })
    dispatch(reset('dialogValues'))
  }
}

export const showDialog = (dialogState, dialogAction) => ({ type: SHOW_DIALOG, dialogState, dialogAction })

export default reducer
